'use client';

import { usePathname } from 'next/navigation';

export function pathnameToSlug(pathname: string) {
  return pathname.split('/').filter(Boolean).join('/').toLowerCase();
}

export function HideOnPages({
  slugs,
  children,
}: {
  slugs: string[];
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  if (slugs.includes(pathnameToSlug(pathname))) return null;

  return <>{children}</>;
}
